import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../../utils/tpoGenQueryKeys';
import type { OptimiseResultResponse } from '../../../../types/optimiseResult';

const useGetOptimisedResults = (jobId: string | null, planId: string) => {
    return useQuery({
        queryKey: tpoGenKeys.optimisedResults(jobId ?? '', planId),
        queryFn: async (): Promise<OptimiseResultResponse> => {
            const response = await axios.get(tpoGenUrls.getOptimisedResults, {
                params: { job_id: jobId, plan_id: planId },
            });
            return response.data;
        },
        enabled: !!jobId && !!planId,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};

export default useGetOptimisedResults;
